<sew-ws-header
    #header
    oscHeaderEvents
    [baseUrl]="baseURL"
    [caasBaseUrl]="caasBaseUrl"
    [apiBaseUrl]="apiBaseUrl"
    [useTracking]="true"
    [useCMP]="useCMP"
    [isPreview]="environment.preview"
    [attr.countryCode]="environment.preview ? currentCountry : null"
    [environment]="stage"
    [redirectUri]="postLoginUrl"
    [postLogoutRedirectUri]="postLogoutUrl"
    [clientId]="authConfig.clientId"
    [policy]="authConfig.policy"
    [scopes]="authConfig.scopes"
    [transparent]="!environment.preview"
></sew-ws-header>
<div
    class="infinite"
    infiniteScroll
    [infiniteScrollDistance]="0.5"
    [infiniteScrollThrottle]="50"
    (scrolled)="onScroll()"
>
    <div class="content">
        <router-outlet></router-outlet>
    </div>
</div>
@if (contactButtonUrl.length > 0) {
    <sew-ws-floating-buttons-contact-options [contactApiUrl]="contactButtonUrl">
    </sew-ws-floating-buttons-contact-options>
}
@if (language.length > 0 && countryCode.length > 0) {
    <sew-ws-footer-api
        [caasBaseUrl]="caasBaseUrl"
        [countryCode]="countryCode"
        [language]="language.toUpperCase()"
        [displayNewestBlogPost]="displayFooterBlogPost"
    >
        @for (link of footerLinks; track link) {
            <a slot="additional-legal-links" [href]="link.url" [target]="link.target"> {{ link.text }}</a>
        }
    </sew-ws-footer-api>
}
